<template>
  <v-list-item v-if="listItem" :disabled="disabled" @click="toggleFavoriteState">
    <v-list-item-icon>
      <v-icon>{{ isFavorite ? mx_icons.favoriteIconActive : mx_icons.favoriteIcon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-subtitle class="wrap-normal">{{ isFavorite ? $t('unmarkFavorite') : $t('markAsFavorite') }} </v-list-item-subtitle>
  </v-list-item>

  <icon-text-btn
    v-else
    :disabled="disabled"
    @onClick="toggleFavoriteState"
    :icon="isFavorite ? mx_icons.favoriteIconActive : mx_icons.favoriteIcon"
    :text="isFavorite ? $t('isFavorite') : $t('noFavorite')"
    :hint="isFavorite ? $t('unmarkFavorite') : $t('markAsFavorite')"
    :iconColor="color"
    :iconOnly="iconOnly"
    :small="small"
    :noWrap="noWrap"
  >
  </icon-text-btn>
</template>

<script>
import common from '@/mixins/common';
import IconTextBtn from './IconTextBtn.vue';
import favoritesService from '@/services/favoritesService';
import eventBus from '@/common/eventBus';
export default {
  name: 'FavoriteIcon',
  mixins: [common],
  components: {
    IconTextBtn,
  },
  props: {
    listItem: { type: Boolean, default: false }, // true to display as list item instead of the icon and text - to be used in a menu for example
    iconOnly: { type: Boolean, default: false }, // true to display the icon without text
    color: String, // the color of the icon and the text
    item: Object, //item with item._userState.favorite and item._moduleId properties
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: true },
    noWrap: { type: Boolean, default: false },
  },
  created() {
    this.init(true);
  },
  beforeDestroy() {
    eventBus.removeEventHandler(eventBus.createFileChangedEventType(this.item));
  },
  data() {
    return {
      isFavorite: favoritesService.isFavorite(this.item),
    };
  },

  methods: {
    eventHandler(eventType, eventObj) {
      // console.debug("received event", eventType, JSON.stringify(eventObj, null, 2))
      // console.debug("is it the same referenced object? id", eventObj.item.id, this.item.id)
      // console.debug("is it the same referenced object? referencial equality", eventObj.item === this.item)

      this.isFavorite = favoritesService.isFavorite(this.item);
    },

    init(newValue, oldValue) {
      // console.debug("init item", this.item._moduleId,this.item.id)
      // If the new file references not the same object as before, we need to register the eventHandler
      // If the oldValue was not null, we need to remove the old handler
      if (newValue !== oldValue) {
        if (oldValue) {
          eventBus.removeEventHandler(eventBus.createFileChangedEventType(oldValue));
        }
        // console.debug("addEventHandler for", eventBus.createFileChangedEventType(this.item))
        if (this.item) {
          eventBus.addEventHandler(eventBus.createFileChangedEventType(this.item), this.eventHandler);
        }
      }

      if (newValue) {
        this.isFavorite = favoritesService.isFavorite(this.item);
      }
    },

    toggleFavoriteState() {
      // console.debug("toggle favorite for ",this.item.title)

      if (!this.isFavorite) {
        console.debug('1. mark as favorite');
        let sendboxTitle = this.$t('action.addFavorite.msg', { title: this.item.title });

        this.$store.dispatch('sendbox/markAsFavorite2', { item: this.item, sendboxTitle }, { root: true });
      } else {
        console.debug('remove from favorite');
        let sendboxTitle = this.$t('action.removeFavorite.msg', { title: this.item.title });
        this.$store.dispatch('sendbox/removeFromFavorite2', { item: this.item, sendboxTitle }, { root: true });
      }

      this.isFavorite = !this.isFavorite;

      console.debug('publish FileChanged Event', this.item._moduleId, this.item.id);
      eventBus.publish({
        selfHandler: this.eventHandler,
        eventType: eventBus.createFileChangedEventType(this.item),
        eventObj: { msg: 'favorite changed', item: this.item },
      });
    },
  },
  watch: {
    // needs to watch for changed items because the component is not aware of changed items otherwise (e.g another file is attached)

    item: {
      handler(newValue, oldValue) {
        if (newValue) {
          console.debug('FavoriteIcon item changed id', newValue._moduleId, newValue.id);
          this.init(newValue, oldValue);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
